import React, { useState } from 'react';
import {
    Paper,
    TableContainer,
    Table,
    TableRow,
    TableHead,
    TableCell,
    makeStyles,
    TableBody,
    TablePagination,
    TableSortLabel,
} from '@material-ui/core';
import PopUp from './PopUp';
import { Download, Preview } from './Preview';
import PayHere from './PayHere';
import { useSelector } from 'react-redux';
import moment from 'moment';

function EnhancedTableHead(props) {
    const { classes, headcells, action, order, orderBy, onRequestSort, post } = props;

    const createSortHandler = (property) => (event) => {
        //console.log("hearderID", property);
        onRequestSort(event, property);
    };
    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
                <TableCell className={classes.TableHeadCss} width="10% !important">
                    SL No
                </TableCell>
                {headcells.map((headRow) => {
                    //console.log(headRow, "Header Row");
                    return (
                        <TableCell key={headRow.id} align="left" sortDirection={orderBy === headRow.id ? order : false}>
                            <TableSortLabel
                                active={orderBy === headRow.id}
                                direction={orderBy === headRow.id ? order : 'asc'}
                                onClick={createSortHandler(headRow.id)}
                            >
                                {headRow.label}
                                {orderBy === headRow.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}{' '}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
                {post === 'admin' && <TableCell align="center"></TableCell>}
                {action && <TableCell align="center">Action</TableCell>}
            </TableRow>
        </TableHead>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    tableRow: {
        height: '50px',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

function descendingComparator(a, b, orderBy) {
    const x = typeof a[orderBy] === 'string' ? a[orderBy].toLowerCase() : a[orderBy];
    const y = typeof b[orderBy] === 'string' ? b[orderBy].toLowerCase() : b[orderBy];
    if (y < x) {
        return -1;
    }
    if (x > y) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => {
        return el[0];
    });
}

const ActionTable = ({ headcells, action, rows, mode, post, generate, prvnxtbt, pageDetails, handleCount }) => {
    // const { headcells, action, rows, mode, post, generate } = props; // need to remove
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const classes = useStyles();

    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    function numberWithCommas(x) {
        x = x.toString();
        const IndianCur = new Intl.NumberFormat('en-IN').format(parseFloat(x.replace(/,/g, '')));
        return IndianCur;
    }
    //  row data
    const rowData = (row) => {
        return headcells.map((col) => {
            if (col.isConcat && row[col.id]) {
                const subdata = row[col.id];
                const mergedData = col.concatElem.map((concatdata) => {
                    return concatdata.split('.').reduce((acc, item) => {
                        if (Object.prototype.hasOwnProperty.call(acc, item)) {
                            return acc[item];
                        }
                        return '';
                    }, subdata);
                });
                return (
                    <TableCell align="left" key={col.id}>
                        {mergedData.join(', ')}
                    </TableCell>
                );
            }
            if (col.id === 'employeeId') {
                return (
                    <TableCell align="left" key={col.id}>
                        {row.requestedEmpId}
                    </TableCell>
                );
            }
            if (col.id === 'employeeName') {
                return (
                    <TableCell align="left" key={col.id}>
                        {row.requestedEmpFirstName} {row.requestedEmpLastName}
                    </TableCell>
                );
            }
            // if (col.id === 'buyerFirstName') {
            //     return (
            //         <TableCell align="left" key={col.id}>
            //             {row.requestedBuyerFirstName} {row.requestedBuyerLastName}
            //         </TableCell>
            //     );
            // }
            if (col.id === 'totalAmount') {
                return (
                    <TableCell align="left" key={col.id}>
                        {/* {Math.round(row.amountChargeable)} */}
                        {numberWithCommas(row.amountChargeable)}
                    </TableCell>
                );
            }

            // if (col.id === 'requestInvoicedate') {
            //     // console.log('rowResponse', col);

            //     const date = new Date(row.requestInvoicedate === null ? '' : row.requestInvoicedate);

            //     const requestInvoicedate = moment(date).format('DD-MM-YYYY');
            //     return (
            //         <TableCell align="left" key={col.id}>
            //             {requestInvoicedate}
            //         </TableCell>
            //     );
            // }
            // if (col.id === 'invoiceDate') {
            //     // console.log('rowResponse', row);
            //     const date = new Date(row.invoiceDate);
            //     const invoiceDate = moment(date).format('DD-MM-YYYY');
            //     return (
            //         <TableCell align="left" key={col.id}>
            //             {invoiceDate}
            //         </TableCell>
            //     );
            // }
            let data = '';
            if (col.label === 'Status' && row[col.id] === true) {
                data = 'Paid';
            } else if (col.label === 'Status' && row[col.id] !== true) {
                if (post === 'ultimate') {
                    data = 'Unpaid';
                } else {
                    usertype === 'SUPERADMIN' || post === 'admin' ? (data = 'Unpaid') : (data = <PayHere row={row} />);
                }
            } else {
                data = row[col.id];
            }
            const tabledata = (
                <TableCell align="left" key={col.id}>
                    {data}
                </TableCell>
            );
            return tabledata;
        });
    };

    // Action ICONS
    const actionData = (amode, arow, apost, agenerate) => {
        let taction;
        if (amode === 'generate') {
            taction = (
                <div key={amode}>
                    <PopUp mode={amode} row={arow} post={apost} generate={agenerate} />
                </div>
            );
        } else if (amode === 'view') {
            taction = (
                <div key={amode}>
                    <Download mode={amode} Icon="download" row={arow} post={apost} />
                    <Preview mode={amode} Icon="preview" row={arow} post={apost} />
                </div>
            );
        } else {
            taction = (
                <div key={amode}>
                    <Download mode={amode} Icon="download" row={arow} post={apost} />
                </div>
            );
        }
        return taction;
    };

    const pagination = (propsPagination) => {
        handleCount(propsPagination);
    };

    const pagin = () => {
        const pag = (
            <div style={{ float: 'right', padding: ' 16px', display: 'flex', alignItems: 'baseline' }}>
                <div style={{ marginLeft: '10px', paddingBottom: '6px' }}>
                    Showing {pageDetails && pageDetails.number + 1} of {pageDetails && pageDetails.totalPages} Pages
                </div>

                {pageDetails && pageDetails.totalPages > 1 ? (
                    <>
                        <button className="checklistBtn-openService PNButton" onClick={() => pagination('prev')} disabled={prvnxtbt.prvBt}>
                            Previous
                        </button>

                        <button className="checklistBtn-openService PNButton" onClick={() => pagination('next')} disabled={prvnxtbt.nxtBt}>
                            Next
                        </button>
                    </>
                ) : (
                    ''
                )}
            </div>
        );
        return pag;
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <TableContainer>
                    <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table" size="medium">
                        {/* <colgroup>
                            <col style={{ width: '5%' }} />
                            <col style={{ width: '15%' }} />
                            <col style={{ width: '25%' }} />
                        </colgroup> */}
                        <EnhancedTableHead
                            classes={classes}
                            headcells={headcells}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            action={action}
                            post={post}
                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const rowDataShow = rowData(row);
                                    let slno = 1;
                                    if (page > 0) {
                                        slno = page * rowsPerPage + 1;
                                    }
                                    slno += index;
                                    return (
                                        <TableRow hover tabIndex={-1} key={slno} className={classes.tableRow}>
                                            <TableCell>
                                                {pageDetails && pageDetails.number > 0 ? slno + pageDetails.number * 10 : slno}
                                            </TableCell>
                                            {rowDataShow}
                                            {post === 'admin' && <TableCell align="center"></TableCell>}
                                            {action && (
                                                <TableCell align="center">
                                                    {/* {
                                                            actionIcons.map(icon => {
                                                                ////console.log(icon ,"Icons From Parent")

                                                               return ( icon.mode === 'generate' ? (
                                                                            <div key={icon.mode}> 
                                                                                <PopUp mode={icon.mode} Icon={icon.icon} row={row} post={post} generate={generate} />
                                                                            </div>
                                                                        ) :
                                                                        icon.mode === 'download' ? (
                                                                            <div key={icon.mode}>
                                                                            <Preview mode={icon.mode} Icon={icon.icon} row={row} post={post} />
                                                                            </div>
                                                                        ) : (
                                                                            <div key={icon.mode}>
                                                                                <Preview mode={icon.mode} Icon={icon.icon} row={row} post={post} />
                                                                            </div>)
                                                               )
                                                                        }) 
                                                        } */}
                                                    {actionData(mode, row, post, generate)}
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                // <TableRow>
                                //     <TableCell style={{ height: 53 * emptyRows }} colSpan={7} />
                                // </TableRow>
                                <></>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* <TablePagination
                    rowsPerPageOptions={[10]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                /> */}
                {pagin()}
            </Paper>
        </div>
    );
};

export default ActionTable;
